<template>
  <page-view title="繁星淘客经济体">
    <div slot="headerContent">
      <p style="font-size: 14px;color: rgba(0,0,0,.65)">{{ description }}</p>
      <div class="link" :style="{marginBottom:'20px'}">
        <a :href="'http://www.eccunion.net'" target="_blank">
          <span>繁星淘客经济体官网</span>
        </a>
        <a :href="'https://wpa.qq.com/msgrd?v=3&uin=11726691&site=qq&menu=yes'" target="_blank">
          <span>联系客服</span>
        </a>
      </div>
    </div>
    <div slot="extra">
      <div class="extra-img">
        <img v-if="typeof extraImage !== 'undefined'" :src="extraImage" />
      </div>
    </div>
    <div class="card-list" ref="content">
      <a-spin :spinning="loading">
        <a-list :grid="{gutter: 24, lg: 3, md: 2, sm: 1, xs: 1}" :dataSource="list">
          <a-list-item slot="renderItem" slot-scope="item">
            <template v-if="item == 1">
              <a-button class="new-btn" type="dashed" @click="handleAddRobot">
                <a-icon type="plus" />加入经济体
              </a-button>
            </template>
            <template v-else>
              <a-card :hoverable="false">
                <a-card-meta>
                  <div style="margin-bottom: 3px" slot="title">{{ item.get_sub_user_list.nickname }}</div>
                  <a-avatar
                    class="card-avatar"
                    slot="avatar"
                    icon="user"
                    :src="item.get_sub_user_list.wx_avatar"
                    size="large"
                  />
                  <div class="meta-content" slot="description">
                    <a-tooltip placement="top">
                      <template slot="title">
                        <div>项目ID：{{item.project_id}}</div>
                        <div>机器人ID：{{item.sub_id}}</div>
                        <div>加入时间：{{item.create_time*1000 | moment("YYYY-MM-DD")}}</div>
                        <div>短链接：{{item.project_url?item.project_url:'暂无'}}</div>
                      </template>
                      <div :style="{ fontSize: '13px',lineHeight: 1.6}">
                        <span v-line-clamp="1">项目ID：{{item.project_id}}</span>
                        <span v-line-clamp="1">机器人ID：{{item.sub_id}}</span>
                        <span v-line-clamp="1">加入时间：{{item.create_time*1000 | moment("YYYY-MM-DD")}}</span>
                        <span v-line-clamp="1">短链接：{{item.project_url?item.project_url:'暂无'}}</span>
                      </div>
                    </a-tooltip>
                  </div>
                </a-card-meta>
                <div class="card-status">
                  <a-badge v-if="item.project_url" status="success" text="已通过" />
                  <a-badge v-else status="processing" text="审核中" />
                </div>
                <!-- <template class="ant-card-actions" slot="actions">
                  <a @click="handleDelete([item.sub_id])">移除</a>
                </template>-->
              </a-card>
            </template>
          </a-list-item>
        </a-list>
      </a-spin>
      <multiple-select-robot-modal ref="multipleSelectRobotModal" @change="handleSelectRobot"></multiple-select-robot-modal>
    </div>
  </page-view>
</template>

<script>
import MultipleSelectRobotModal from '@/views/innovate/modules/MultipleSelectRobotModal'
import InnovateEccApi from '@/api/innovate-ecc'
import moment from 'moment'
import { PageView } from '@/layouts'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'InnovateEcc',
  components: {
    MultipleSelectRobotModal,
    PageView
  },
  data() {
    return {
      description: '2020年正式进入淘客资本化时代，加入繁星经济体，开启淘客收益新模式：佣金收益+资本收益。',
      extraImage: 'https://gw.alipayobjects.com/zos/rmsportal/RzwpdLnhmvDJToTdfDPe.png',
      dataSource: [],
      pagination: {
        pageSize: 200,
        current: 0
      },
      list: [1],
      loading: false,
      whole: false
    }
  },
  created() {
    this.getData(true)
  },
  methods: {
    ...mapGetters(['userInfo']),
    handleAddRobot() {
      const that = this
      that.$refs.multipleSelectRobotModal.show()
    },
    handleSelectRobot(data) {
      const dataarr = data.map(item => {
        console.log(item)
        const data = {
          sub_id: item.id,
          join_nianchu_time: item.create_time
            ? moment(new Date(item.create_time * 1000)).format('YYYY-MM-DD HH:mm:ss')
            : '',
          nickname: item.nickname,
          avatar: item.wx_avatar
        }
        return data
      })
      InnovateEccApi.addRobot({ create_ecc_params: JSON.stringify(dataarr) })
        .then(res => {
          if (res.code === 1) {
            this.getData(true)
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.pullLoading = false
        })
    },
    getData(first) {
      this.loading = true
      InnovateEccApi.getList({
        pageSize: this.pagination.pageSize,
        pageNo: first ? 1 : this.pagination.current + 1
      })
        .then(res => {
          if (res.data.length == 0) {
            this.whole = true
            return
          }
          if (first) {
            res.data.unshift(1)
            this.list = res.data
          } else {
            this.list = this.list.concat(res.data)
          }
          this.pagination.current = res.pageNo
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete(ids) {
      console.log(ids)
      // const userInfo = this.userInfo()
      // const dataarr = ids.map((id)=>{
      //   return {
      //     main_id: userInfo.id,
      //     sub_id: id
      //   }
      // })
      // let loading = this.$message.loading('正在删除')
      // InnovateEccApi.removeRobot({ params: JSON.stringify(dataarr) })
      //   .then(res => {
      //     if (res.code === 1) {
      //       this.$message.success('删除成功')
      //       this.getData(true)
      //     } else {
      //       this.$message.error(res.msg)
      //     }
      //   })
      //   .finally(() => {
      //     this.$message.destroy(loading)
      //   })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 24px 24px 0;
  .link {
    margin-top: 16px;
    &:not(:empty) {
      margin-bottom: 16px;
    }
    a {
      margin-right: 32px;
      height: 24px;
      line-height: 24px;
      display: inline-block;
      i {
        font-size: 24px;
        margin-right: 8px;
        vertical-align: middle;
      }
      span {
        height: 24px;
        line-height: 24px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
}
.page-menu-search {
  text-align: center;
  margin-bottom: 16px;
}
.page-menu-tabs {
  margin-top: 48px;
}

.extra-img {
  margin-top: -60px;
  text-align: center;
  width: 195px;

  img {
    width: 100%;
  }
}

.mobile {
  .extra-img {
    margin-top: 0;
    text-align: center;
    width: 96px;

    img {
      width: 100%;
    }
  }
}

.card-avatar {
  width: 48px;
  height: 48px;
  border-radius: 48px;
}

.ant-card-actions {
  background: #f7f9fa;
  li {
    float: left;
    text-align: center;
    margin: 12px 0;
    color: rgba(0, 0, 0, 0.45);
    width: 50%;

    &:not(:last-child) {
      border-right: 1px solid #e8e8e8;
    }

    a {
      color: rgba(0, 0, 0, 0.45);
      line-height: 22px;
      display: inline-block;
      width: 100%;
      &:hover {
        color: #1890ff;
      }
    }
  }
}

.new-btn {
  background-color: #fff;
  border-radius: 2px;
  width: 100%;
  height: 152px;
}

.meta-content {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  height: 80px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.card-status {
  position: absolute;
  top: 15px;
  right: 15px;
}
</style>
